import '../../../styles/src/05-components/banner-form/style.scss';

document.addEventListener(
    "DOMContentLoaded", () => {
        // Change color of select upon selecting an option
        let mySelect = document.querySelector('.banner-form__form-container .gform_wrapper.gravity-theme .ginput_container_address span select');
        if (mySelect) {
            mySelect.addEventListener('change', (event) => {
                const current = mySelect.value;
                if (current == '') {
                    mySelect.style.color = 'unset';
                    mySelect.style.fontWeight = '400';
                } else {
                    mySelect.style.color = 'var(--color__biscay)';
                    mySelect.style.fontWeight = '700';
                }
            });
        }
    }
);